import { Form, Row, Col, Button, Select, Input } from "antd";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchCategory } from "../../../redux/slice/categorySlice";
import { queryCategory } from "../../../utils/constants/query";

function PostSearch(props: any) {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const categories = useAppSelector((state) => state.category.result);

  useEffect(() => {
    dispatch(fetchCategory({ query: queryCategory }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  let arrSelect = categories?.map((item: any, index) => ({
    value: item._id,
    label: item.name,
  }));

  const onFinish = async (values: any) => {
    let query = "";
    if (values.category) {
      query += `&categoryId=${values.category}`;
    }
    if (values.title) {
      query += `&title=${values.title}`;
    }

    if (values.title || values.category) {
      props.handleSearch(query);
    } else {
      props.handleSearch("");
    }
  };

  const resetForm = () => {
    form.resetFields();
  };
  return (
    <Form form={form} onFinish={onFinish}>
      <Row
        gutter={24}
        style={{
          background: "#fff",
          paddingTop: 25,
          margin: 0,
          marginBottom: 20,
          borderRadius: 6,
        }}>
        <Col span={8}>
          <Form.Item name="category" label="Thể loại">
            <Select
              showSearch
              placeholder="Tìm kiếm thể loại bài viết..."
              optionFilterProp="children"
              filterOption={filterOption}
              options={arrSelect}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="title" label="Title">
            <Input placeholder="Tìm kiếm tiêu đề bài viết..." />
          </Form.Item>
        </Col>
        <Col
          span={8}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 25,
          }}>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
            style={{ marginRight: 12 }}>
            Tìm kiếm
          </Button>
          <Button type="primary" danger onClick={resetForm}>
            Làm lại
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default PostSearch;
